import { StyleSheet } from '@react-pdf/renderer';

// WM brand colors
const COLORS = {
  primary: '#1a5568',
  primaryDark: '#1f497d',
  headerBg: '#e5e7eb',
  headerText: '#374151',
  borderLight: '#e5e7eb',
  borderMedium: '#d1d5db',
  zebraRow: '#f3f4f6',
  white: '#ffffff',
  textPrimary: '#111827',
  textSecondary: '#6b7280',
  textMuted: '#9ca3af'
};

/**
 * Build PDF styles from report config layout settings.
 */
const buildStyles = (layout = {}) => {
  const fontSize = layout.fontSize || 8;
  const headerFontSize = layout.headerFontSize || 10;

  return StyleSheet.create({
    page: {
      paddingTop: 30,
      paddingBottom: 40,
      paddingHorizontal: 24,
      fontFamily: 'Helvetica',
      fontSize: fontSize
    },

    // ===== Page Header =====
    headerContainer: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      marginBottom: 8,
      paddingBottom: 6,
      borderBottomWidth: 2,
      borderBottomColor: COLORS.primary
    },
    headerLeft: {
      flexDirection: 'column',
      width: '25%'
    },
    headerLogo: {
      height: 24,
      maxWidth: 120,
      objectFit: 'contain',
      objectPosition: 'left top',
      marginBottom: 3
    },
    headerAddress: {
      fontSize: 6,
      color: COLORS.textSecondary,
      lineHeight: 1.4
    },
    headerCenter: {
      width: '25%',
      textAlign: 'center',
      alignSelf: 'center',
      justifyContent: 'center'
    },
    headerTitle: {
      fontSize: 14,
      fontFamily: 'Helvetica-Bold',
      color: COLORS.primaryDark,
      textTransform: 'uppercase',
      letterSpacing: 1
    },
    headerRight: {
      width: '50%',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    paramRow: {
      flexDirection: 'row',
      marginBottom: 2
    },
    paramColumn: {
      paddingLeft: 6
    },
    paramLabel: {
      fontSize: 6.5,
      fontFamily: 'Helvetica-Bold',
      color: COLORS.headerText,
      borderBottomWidth: 0.5,
      borderBottomColor: COLORS.borderMedium,
      paddingBottom: 1,
      marginBottom: 2
    },
    paramValue: {
      fontSize: 6,
      color: COLORS.textSecondary,
      lineHeight: 1.5
    },
    paramNone: {
      fontSize: 6,
      color: COLORS.textMuted,
      fontStyle: 'italic'
    },

    // ===== Data Table =====
    table: {
      width: '100%'
    },
    tableHeaderRow: {
      flexDirection: 'row',
      backgroundColor: COLORS.headerBg,
      borderBottomWidth: 1.5,
      borderBottomColor: COLORS.borderMedium
    },
    tableHeaderCell: {
      fontSize: headerFontSize * 0.65,
      fontFamily: 'Helvetica-Bold',
      color: COLORS.headerText,
      textTransform: 'uppercase',
      letterSpacing: 0.3,
      paddingVertical: 4,
      paddingHorizontal: 3,
      borderRightWidth: 0.5,
      borderRightColor: COLORS.borderMedium
    },
    tableRow: {
      flexDirection: 'row',
      borderBottomWidth: 0.5,
      borderBottomColor: COLORS.borderLight
    },
    tableRowZebra: {
      flexDirection: 'row',
      borderBottomWidth: 0.5,
      borderBottomColor: COLORS.borderLight,
      backgroundColor: COLORS.zebraRow
    },
    tableCell: {
      fontSize: fontSize,
      color: COLORS.textPrimary,
      paddingVertical: 2.5,
      paddingHorizontal: 3,
      borderRightWidth: 0.5,
      borderRightColor: COLORS.borderLight
    },

    // ===== Page Footer =====
    footer: {
      position: 'absolute',
      bottom: 16,
      left: 24,
      right: 24,
      flexDirection: 'row',
      justifyContent: 'space-between',
      fontSize: 7,
      color: COLORS.textMuted,
      borderTopWidth: 0.5,
      borderTopColor: COLORS.borderLight,
      paddingTop: 4
    }
  });
};

export default buildStyles;
export { COLORS };
